<template>
  <div class="tabs_content">
    <section>
      <div class="left">
        <detail-entity-info
            :entity="entity"
        >
          <template v-slot:pre-data v-if="logo">
            <p class="profile_image_box">
              <label class="profile_image logo"><img :src="logo"></label>
            </p>
          </template>
          <p>
            <translate class="translate">Zdroj</translate>:<br/><a @click="goToOrigin(entity.origin_url)" v-translate>Zdrojový balíček</a></p>
        </detail-entity-info>
      </div>
      <div class="right">
        <div class="field_left">
          <text-input id="vodprovidername"
                      :required="true"
                      v-model="entity.name"
                      :disabled="true"
                      ref="nameref"
          >
            <translate class="translate">Název</translate>
          </text-input>
        </div>
          <checkbox-input id="vodprovideractive"
                      :required="true"
                      v-model="entity.active"
                      :disabled="true"
                      ref="activeref"
          >
            <translate class="translate">Aktivní</translate>
          </checkbox-input>
        <textarea-input id="vodproviderdescription" rows=6 cols=50
                        v-model="entity.description"
                        :disabled="true"
        >
          <translate class="translate">Popis</translate>
        </textarea-input>
      </div>
    </section>
  </div>
</template>
<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";

export default {
  name: "Settings",
  components: {DetailEntityInfo},
  props: {
    entity: Object
  },
  computed: {
    logo(){
      if(this.entity.logo !== null){
        return this.entity.logo.path + '/' + this.entity.logo.file;
      }
    }
  },
  methods: {
    goToOrigin(url) {
      window.open(url, '_blank');
    }
  },
}
</script>





// WEBPACK FOOTER //
// src/components/views/vodProviders/detail/Settings.vue